/**
 * Mobile Menu — Toggle hamburger + nav menu
 */
(function ($) {
    'use strict';

    var $hamburger = $('#navHamburger');
    var $menu = $('#navMenu');

    if (!$hamburger.length || !$menu.length) return;

    $hamburger.on('click', function () {
        $(this).toggleClass('active');
        $menu.toggleClass('open');
    });

    // Fecha ao redimensionar pra desktop
    $(window).on('resize', function () {
        if ($(window).width() > 991) {
            $menu.removeClass('open');
            $hamburger.removeClass('active');
        }
    });

    // Fecha ao clicar num link
    $menu.find('a').on('click', function () {
        $menu.removeClass('open');
        $hamburger.removeClass('active');
    });

})(jQuery);
